<template>
    <div class="sub-assignments-edit-nav-wrapper">
        <div
            class="sub-assignments-edit-nav"
            role="tablist">
            <draggable
                group="navparts"
                :list="assignmentIn.sub_assignments"
                handle=".sub-assignment-drag-handle"
                @change="subAssignmentsOrderChanged()"
                ghost-class="ghost">
                <design-2021-lesson-module-assignment-sub-assignment-pages-nav-component
                    v-for="subAssignment in assignmentIn.sub_assignments"
                    :key="subAssignment.id"
                    @selected-sub-assignment="selectSubAssignment"
                    @sub-assignment-updated="updateSubAssignment"
                    :sub-assignment-in="subAssignment"
                    :selected="subAssignment.id === selected">
                </design-2021-lesson-module-assignment-sub-assignment-pages-nav-component>
            </draggable>
        </div>

        <div class="add-sub-assignment">
            <b-button
                class="btn-recycle btn-restore-sub-assignment"
                variant="outline-primary"
                @click="showRestoreSubAssignmentModal">
                {{ $t('assignment.restore_sub_assignment') }}
            </b-button>

            <b-button
                class="btn-add btn-add-sub-assignment"
                @click="openCreateSubAssignmentModal"
                variant="primary">
                {{ $t('assignment.add_sub_assignment') }}
            </b-button>

            <design-2021-lesson-module-assignment-add-sub-assignment-modal-component
                :assignment-in="assignmentIn"
                ref="create-sub-assignment-modal"
                @sub-assignment-added="subAssignmentAdded($event)">
            </design-2021-lesson-module-assignment-add-sub-assignment-modal-component>

            <design-2021-portfolio-edit-restore-sub-assignment-modal-component
                :assignment-in="assignmentIn"
                @sub-assignment-restored="subAssignmentRestored($event)"
                ref="restore-sub-assignment-modal">
            </design-2021-portfolio-edit-restore-sub-assignment-modal-component>
        </div>
    </div>
</template>

<script>
import draggable from 'vuedraggable';

export default {
    name: 'design-2021-lesson-module-assignment-sub-assignments-nav-component',
    components: {
        draggable,
    },
    props: {
        assignmentIn: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            selected: null,
            holds: [],
        };
    },
    mounted() {
        if (!this.assignmentIn.sub_assignments.length) {
            this.$bvModal.show('add-sub-assignment-modal');
        }

        const name = 'assignment-edit-selected-sub-assignment-' + this.assignmentIn.id;
        const storage_value = parseInt(localStorage.getItem(name));
        if (storage_value) {
            for (const subAssignment of this.assignmentIn.sub_assignments) {
                if (subAssignment.id === storage_value) {
                    this.selected = storage_value;
                    this.$emit('selected-sub-assignment', storage_value);
                }
            }
        } else {
            if (this.assignmentIn.sub_assignments.length) {
                this.selected = this.assignmentIn.sub_assignments[0].id;
                this.$emit('selected-sub-assignment', this.assignmentIn.sub_assignments[0].id);
            }
        }
    },
    methods: {
        openCreateSubAssignmentModal() {
            this.$refs['create-sub-assignment-modal'].show();
        },

        showRestoreSubAssignmentModal() {
            this.$refs['restore-sub-assignment-modal'].show();
        },
        selectSubAssignment(id) {
            this.selected = id;
            const name = 'assignment-edit-selected-sub-assignment-' + this.assignmentIn.id;
            localStorage.setItem(name, id);
            this.$emit('selected-sub-assignment', id);
        },
        subAssignmentsOrderChanged() {
            let blocks = [];

            this.assignmentIn.sub_assignments.forEach((subAssignment, i) => {
                blocks.push({
                    id: subAssignment.id,
                    order: i + 1,
                });
            });

            const data = {
                assignment_id: this.assignmentIn.id,
                blocks: blocks,
            };

            this.axios.post(this.routes.subAssignmentOrder(), data).then(
                (response) => {},
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        subAssignmentAdded(subAssignment) {
            this.$emit('sub-assignment-added', subAssignment);
            this.selectSubAssignment(subAssignment.id);
        },
        subAssignmentRestored(subAssignment) {
            this.$emit('sub-assignment-added', subAssignment);
            this.selectSubAssignment(subAssignment.id);
        },
        updateSubAssignment(updatedSubAssignment) {
            this.$emit('sub-assignment-updated', updatedSubAssignment);
        },
    },
};
</script>

<style scoped lang="scss">
.ghost {
    background-color: darken($secondary-background-color, 10%);
}

.sub-assignments-edit-nav-wrapper {
    margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
}

.add-sub-assignment {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    row-gap: map-get($grid-gutter-spacing, 'twenty-one');

    .btn {
        width: 225px;

        &:first-child {
            margin-top: map-get($grid-gutter-spacing, 'forty-two');
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'lg')) {
    .add-sub-assignment {
        align-items: flex-start;
    }
}
</style>
